import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { MarketingFeatureCompareList } from '@app/components/stateless/marketing/features-compare'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { Header, Header2 } from '@app/components/general/header'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/why-us',
    }),
  }
}

function WhyUs() {
  const { t } = useTranslation('why-us')

  return (
    <MarketingDrawer>
      <SectionContainer block container>
        <Header>{t('header')}</Header>
        <Paragraph>{t('header-details')}</Paragraph>
        <Header2>{t('tcompare')}</Header2>
        <Paragraph>{t('tcompare-list')}</Paragraph>
        <MarketingFeatureCompareList header4 />
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { WhyUs },
  {
    translation: 'why-us',
  }
)
